import WPSResource from '../../../WPS.resource';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { ROOT_REDUCER_KEYS, WORKSPACE_SG_ACTION_KEYS } from '../../workspaceSettingsReducer';
export const defaultReducerState = getDefaultAsyncWrapperObj();
const workspaceSecurityGroupsPutPrefix = 'WorkspaceSecurityGroupsPut';
const workspaceSecurityGroupsPutEpicReducerArg = {
    actionPrefix: workspaceSecurityGroupsPutPrefix,
    reduxKeyNested: (inputPayload) => [
        ROOT_REDUCER_KEYS.WORKSPACE_SG,
        WORKSPACE_SG_ACTION_KEYS.PUT,
    ],
    loadResource: (request) => {
        return WPSResource.putWorkspaceSecurityGroups(request.workspaceId, request.data);
    },
    onCompleteSuccess: (resourcesResult) => resourcesResult,
};
export const workspaceSecurityGroupsPutEpicReducer = loadResourcesUtils(workspaceSecurityGroupsPutEpicReducerArg);

//# sourceMappingURL=PutWorkspaceSecurityGroups.ducks.js.map
